import { createSelector, createStructuredSelector } from 'reselect';
import { AVC_NAMESPACE } from 'Container/App/constants';
import { initialState } from './reducer';
import { RootState } from 'Container/App/types';
import {
    selectActiveOverlay,
    selectAddress,
    selectAvcResult,
    selectContentEnabled,
    selectHomesPassed,
    selectIsOverlayOpen,
    selectTariff,
} from 'Container/App/selector';

const selectState = (state: RootState) => state[AVC_NAMESPACE] || initialState;

export const selectAvcState = createSelector(selectState, state => state);
export const selectLoading = createSelector(selectState, state => state.loading);
export const selectAddresses = createSelector(selectState, state => state.addresses);
export const selectAvcForm = createSelector(selectState, state => state.addressForm);
export const selectError = createSelector(selectState, state => state.error);
export const selectAccessSupplier = createSelector(selectState, state => state.accessSupplier);
export const selectAvailabilityIndicator = createSelector(selectState, state => state.availabilityIndicator);

export const selectors = createStructuredSelector({
    isLoading: selectLoading,
    avcForm: selectAvcForm,
    address: selectAddress,
    addresses: selectAddresses,
    error: selectError,
    avcResult: selectAvcResult,
    selectedTariff: selectTariff,
    activeOverlay: selectActiveOverlay,
    isOverlayOpen: selectIsOverlayOpen,
    isContentEnabled: selectContentEnabled,
    homesPassedType: selectHomesPassed,
    accessSupplier: selectAccessSupplier,
    availabilityIndicator: selectAvailabilityIndicator,
});
